import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpService } from '../../services';
import { BaseComponent } from '../base';


/**
 * Help info component.
 */
@Component({
	selector: 'app-help',
	templateUrl: './help.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class HelpComponent extends BaseComponent implements OnInit {

	public activeModal = inject(NgbActiveModal);
	private readonly helpSrv = inject(HelpService);

	safeUrl: SafeResourceUrl | null = null;

	ngOnInit(): void {
		if (this.helpSrv.isLoaded) {
			this.safeUrl = this.helpSrv.safeUrl;
		} else {
			const lang = this.langSrv.currentLang;
			this.helpSrv.loadFileNames(lang).subscribe(() => this.safeUrl = this.helpSrv.safeUrl);
		}
	}

}
